<template>
    <v-dialog v-model="show" max-width="760px">
        <template slot="activator" slot-scope="{ on }">
            <v-btn bottom color="accent" dark fab fixed right @click="create">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>

        <v-card v-if="show">
            <v-card-title>
                <span v-if="!editItem._id" class="subtitle-1 font-weight-bold">CP 신규등록</span>
                <span v-else class="subtitle-1 font-weight-bold">CP 수정</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.username" label="아이디" placeholder=" " hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-password-field v-model="editItem.password" label="비밀번호" placeholder=" " hide-details></v-password-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.name" label="이름" placeholder=" " hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.phone" label="연락처" placeholder=" " hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.email" label="이메일" placeholder=" " hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.postcode" label="우편번호" placeholder=" " hide-details readonly @click="$refs['daum-postcode'].open()"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.address1" label="기본주소" placeholder=" " hide-details readonly @click="$refs['daum-postcode'].open()"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.address2" label="상세주소" placeholder=" " hide-details></v-text-field>
                    </v-col>
                </v-row>

                <!-- <div class="subtitle-2 font-weight-bold mt-6">Risk Management</div>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.maxPrice" label="발행 한도(일간)" placeholder=" " hide-details></v-text-field>
                    </v-col>
                </v-row> -->

                
            </v-card-text>

            <v-divider />

            <v-card-text>
                <div class="subtitle-1 pt-4 d-flex">
                    <strong>발행 금액 제한</strong>
                    <v-spacer />
                    <v-switch v-model="editItem.riskManagement.limitEnabled" dense hide-details class="mt-0" />
                </div>
                <v-row class="mt-4">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.dailyLimit" label="발행 금액 제한(일간)" type="number" placeholder=" " :disabled="!editItem.riskManagement.limitEnabled" clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.monthlyLimit" label="발행 금액 제한(월간)" type="number" placeholder=" " :disabled="!editItem.riskManagement.limitEnabled" clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />
            
            <v-card-text>
                <div class="subtitle-1 pt-4 d-flex">
                    <strong>사용 처리 허용</strong>
                    <v-spacer />
                    <v-switch v-model="editItem.payable" dense hide-details class="mt-0" />
                </div>
            </v-card-text>

            <v-divider />
            
            <v-card-text>
                <div class="subtitle-1 pt-4 d-flex">
                    <strong>사용자 매치 허용</strong>
                    <v-spacer />
                    <v-switch v-model="editItem.payerMatch" dense hide-details class="mt-0" />
                </div>
            </v-card-text>

            <v-divider />

            <v-card-text>
                <div class="subtitle-1 pt-4 d-flex">
                    <strong>API 발송 옵션</strong>
                    <v-spacer />
                    <v-switch v-model="editItem.riskManagement.apiLimitEnabled" dense hide-details class="mt-0"/>
                </div>
                <v-row class="mt-4">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.apiLimit" label="API 요청 제한 개수" type="number" placeholder=" " :disabled="!editItem.riskManagement.apiLimitEnabled" clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-text>
                <div class="subtitle-1 pt-4"><strong>팝빌</strong></div>
                <v-row class="mt-4">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.businessNumber" label="사업자번호(-제외)" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.companyName" label="회사명" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.customerCenter" label="고객센터" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.plusFriendId" label="채널톡ID" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.username" label="팝빌ID" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.templateCode" label="템플릿코드" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="editItem.popbill.tel" label="발신번호" placeholder=" " clearable outlined background-color="white" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-text class="content">
                <div class="subtitle-1 pt-4"><strong>관리자 알람</strong></div>
                <v-row class="mt-4">
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.alarmPrices[0]" label="잔여 알람금액(1차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(editItem.riskManagement.alarmPrices[0], 0)"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.alarmPrices[1]" label="잔여 알람금액(2차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(editItem.riskManagement.alarmPrices[1], 1)"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.alarmPrices[2]" label="잔여 알람금액(3차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(editItem.riskManagement.alarmPrices[2], 2)"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field v-model="editItem.riskManagement.alarmPrices[3]" label="잔여 알람금액(4차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(editItem.riskManagement.alarmPrices[3], 3)"></v-text-field>
                    </v-col>
                </v-row>

                <v-row no-gutters align="center" class="mt-6">
                    <v-col class="pr-1">
                        <v-text-field v-model="name" label="담당자 이름" placeholder=" " hide-details outlined color="secondary" background-color="white" dense></v-text-field>
                    </v-col>
                    <v-col class="pl-1">
                        <v-text-field v-model="phone" label="알람 연락처" placeholder=" " hide-details outlined color="secondary" background-color="white" dense @keydown.enter="() => { editItem.riskManagement.alarmPhones.push(phone); phone = ''; }"></v-text-field>
                    </v-col>
                    <v-col cols="auto" class="pl-1">
                        <v-btn color="secondary" @click="() => { editItem.riskManagement.alarmPhones.push(phone), editItem.riskManagement.alarmNames[editItem.riskManagement.alarmPhones.length - 1] = name, phone = '', name = ''; }"><v-icon left size="20">mdi-plus</v-icon>추가</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="alarmPhone, index in editItem.riskManagement.alarmPhones" :key="index" cols="auto" class="pr-1">
                        <v-chip close color="secondary" @click:close="editItem.riskManagement.alarmPhones.splice(index, 1), editItem.riskManagement.alarmNames.splice(index, 1)">{{ editItem.riskManagement.alarmNames[index] }} {{ alarmPhone }}</v-chip>
                    </v-col>
                </v-row>
                <v-textarea v-model="editItem.riskManagement.alarmMessage" label="알람 메시지" placeholder=" " outlined color="secondary" background-color="white" hide-details class="mt-4"></v-textarea>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="cancel">취소</v-btn>
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>

            <daum-postcode ref="daum-postcode" @input="({ postcode, address }) => { editItem.postcode = postcode; editItem.address1 = address; }"></daum-postcode>
        </v-card>

        
    </v-dialog>
</template>

<script>
import api from "@/api";
import vPasswordField from '@/components/plugins/vuetify/v-password-field.vue';
import daumPostcode from '@/components/plugins/daum/daum-postcode.vue';

export default {
    components: {
        vPasswordField,
        daumPostcode
    },
    data(){
        return {
            show: false,

            editItem: null,
            defaultItem: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,

                riskManagement: {
                    limitEnabled: false,
                    dailyLimit: 0,
                    monthlyLimit: 0,

                    alarmPrices: [0, 0, 0, 0],
                    alarmPhones: [],
                    alarmMessage: null
                },

                popbill: {
                    businessNumber: "",
                    plusFriendId: "",
                    username: "",
                    tel: "",
                    companyName: "",
                    templateCode: "",
                    customerCenter: ""
                }
            },

            name: "",
            phone: ""
        };
    },
    methods: {
        clear(){
            this.editItem = JSON.parse(JSON.stringify(this.defaultItem));
        },
        open(){
            if(!this.editItem.popbill) this.$set(this.editItem, "popbill", JSON.parse(JSON.stringify(this.defaultItem.popbill)));
            for(let i = 0; i < this.editItem.riskManagement.alarmPrices.length; i++) {
                this.editItem.riskManagement.alarmPrices[i] = this.editItem.riskManagement.alarmPrices[i].format()
            }
            this.show = true;
        },
        create(){
            this.clear();
            this.open();
        },
        close(){
            this.show = false;
        },
        cancel(){
            this.show = false;
        },
        validate(){
            try{
                if(!this.editItem.username) throw new Error("아이디를 입력해주세요");
                if(!this.editItem.password && !this.editItem._id) throw new Error("비밀번호를 입력해주세요");
                if(!this.editItem.name) throw new Error("이름을 입력해주세요");
                if(!this.editItem.phone) throw new Error("연락처를 입력해주세요");
                
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            try{
                if(this.validate()){
                    await this.removeComma();
                    this.editItem._id ? await api.console.cps.put(this.editItem) : await api.console.cps.post(this.editItem);
                    this.close();
                    this.$emit("save");
                }
            }
            catch(error){
                console.log(error);
            }
        },
        change(){
            console.log(12);
        }, 
        createComma(alarmPrices, index) {
            console.log(index, this.editItem.riskManagement.alarmPrices[index]);
            this.editItem.riskManagement.alarmPrices[index] = String(alarmPrices).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        async removeComma() {
            for(let i = 0; i < this.editItem.riskManagement.alarmPrices.length; i++) {
                this.editItem.riskManagement.alarmPrices[i] = this.editItem.riskManagement.alarmPrices[i].replaceAll(",","")
            }
        }
    }
}
</script>